import project from './modules/project'
import accounting from './modules/accounting'
import service from './modules/service'
import unit from './modules/unit'
import me from './modules/me'

export const PROJECT = project
export const ACCOUNTING = accounting
export const SERVICE = service
export const UNIT = unit
export const ME = me
